export const slideBoxStyles = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    mt: 3,
  };
export const BoxStyles = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "15px",
    marginBottom: 5,
  }
  
  
  export const typographyStyles = {
    fontWeight: 600,
    marginBottom: 2,
  };
  

  export const noPaymentTextStyles = {
    variant: "h6",
    color: "error",
  };


  export const buttonStyles = (theme) => {
    const isDark = theme.palette.mode === "dark";
    const neonColor = isDark ? "#0ff" : "#6dcff6";
    const bgColor = isDark ? "#111" : "#fff";
    const textColor = isDark ? "#000" : "#fff";
  
    return {
      position: "relative",
      padding: "12px 18px",
      fontSize: "18px",
      textTransform: "uppercase",
      fontWeight: "bold",
      cursor: "pointer",
      transition: "0.3s",
      color: "#188",
      background: bgColor,
      border: "none",
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: `0 0 5px ${neonColor}`,
  
      "&:hover": {
        background: neonColor,
        color: textColor,
        boxShadow: `0 0 20px ${neonColor}, 0 0 40px ${neonColor}`,
      },
  
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "8px",
        border: `2px solid ${neonColor}`,
        opacity: 0,
        transition: "opacity 0.3s",
      },
  
      "&:hover::after": {
        opacity: 1,
        animation: "neon-glow 1.5s linear infinite",
      },
    };
  };
  
  export const buttonStylesLight = (theme) => ({
    ...buttonStyles(theme),
    backgroundColor: "#1976d2",  // Цвет фона для светлой темы
    "&:hover": {
      backgroundColor: "#1565c0",  // Цвет при наведении для светлой темы
      boxShadow: "0 0 10px 5px rgba(0, 0, 255, 0.7)",  // Свечение при наведении
    },
  });
  
  export const buttonStylesDark = (theme) => ({
    ...buttonStyles(theme),
    backgroundColor: "#444",  // Цвет фона для темной темы
    "&:hover": {
      backgroundColor: "#64b5f6",  // Цвет при наведении для темной темы
      boxShadow: "0 0 10px 5px rgba(0, 0, 255, 0.7)",  // Свечение при наведении
    },
  });
  